<template>
    <section
        :class="`${component} uuid-${config.uuid}`"
        ref="list-container"
        v-show="!props.hide"
    >
        <div :class="`${wrapClass}`">
            <template v-for="child in childrenConfigs">
                <!-- node -->
                <component
                    v-if="child.childComponent !== component && child.childComponent !== COMP_FORM_CONTAINER"
                    :key="child.compConfig.uuid"
                    :is="child.childComponent"
                    :class="[{ item: child.childComponent !== COMP_NODE_TEXT }, `ks-1px-b ${child.childComponent}`]"
                    :originConfig="child.compConfig"
                    :parentOutputPath="outputPath"
                    :activeRadio="activeRadio"
                    ref="children"
                    @click.native="handleClickItem(child.compConfig)"
                ></component>
                <!-- list/form container -->
                <div
                    v-else-if="child.childComponent"
                    :key="child.compConfig.uuid"
                    :class="`item ks-1px-b ${child.childComponent} uuid-${child.compConfig.uuid}`"
                    ref="children"
                    @click="handleClickItem(child.compConfig)"
                >
                    <span class="text">
                        {{ i18n(child.compConfig.props.text) || i18n(child.compConfig.label) }}
                    </span>
                    <i class="mobile-general-form-iconfont icon-nav-forward"></i>
                </div>
            </template>
        </div>
        <div
            v-if="isShowSubmitBtn"
            :class="`${component}-footer`"
        >
            <sp-button
                :disabled="!hasCheckAnyRadio"
                @click="submit"
            >
                {{ i18n(props.btnText) }}
            </sp-button>
        </div>
    </section>
</template>
<script>
import { Button } from '@ks/sharp-ui';
import { COMPONENT_MAP, LIST_COMPONENT } from '../register';
import ComponentConfig from '../classes/component-config';
import { component as COMP_NODE_LINK } from '../mobile-general-form-node-link/props';
import { component as COMP_NODE_RADIO } from '../mobile-general-form-node-radio/props';
import { component as COMP_NODE_TEXT } from '../mobile-general-form-node-text/props';
import { component as COMP_FORM_CONTAINER } from '../mobile-general-form-container/props';
import ComponentBase from '../component-base';
import { component } from './props';

export default {
    name: component,
    components: {
        ...LIST_COMPONENT,
        SpButton: Button,
    },
    extends: ComponentBase,
    computed: {
        output() {
            return this.config.output || '';
        },
        hasCheckAnyRadio() {
            return !!this.activeRadio;
        },
        isShowSubmitBtn() {
            const childrenComps = this.props.children || [];
            return childrenComps.some(comp => comp && comp.component === COMP_NODE_RADIO);
        },
        wrapClass() {
            return this.isShowSubmitBtn ? 'list-wrap' : '';
        },
        childrenConfigs() {
            return (this.props.children || []).map(childConfig => {
                const compConfig = new ComponentConfig(childConfig);
                const childComponent = COMPONENT_MAP[compConfig.component];
                return {
                    compConfig,
                    childComponent,
                };
            });
        },
    },
    data() {
        Object.assign(this, {
            COMP_FORM_CONTAINER,
            COMP_NODE_TEXT,
        });
        return {
            component,
            activeRadio: null,
        };
    },
    watch: {
        'props.pageTitle': {
            immediate: true,
            handler(pageTitle) {
                if (pageTitle) {
                    this.formRoot.$emit('page-title-change', pageTitle);
                }
            },
        },
    },
    methods: {
        handleClickItem(compConfig) {
            // TODO 逻辑设计大失败，这里的compConfig是初始状态的config，也就是说不能拿到更新后的props
            const component = compConfig.component;
            if (component === COMP_NODE_RADIO) {
                this.activeRadio = compConfig;
            } else if (component === COMP_NODE_LINK) {
                // 链接跳转由node-link组件内部处理了
                return;
            } else if (component !== COMP_NODE_TEXT) {
                const payload = {
                    output: compConfig.output,
                    component: compConfig.component,
                };

                this.formRoot.$emit('node-click', payload);

                this.activeRadio = null;
            }
        },
        submit() {
            if (!this.hasCheckAnyRadio) {
                return;
            }

            this.formRoot.$emit('submit-list', this.activeRadio);
        },
    },
};
</script>
<style lang="less" scoped>
@import '../../../assets/style/mixin.less';
.mobile-general-form-list-container {
    .list-wrap {
        margin-bottom: 60px;
    }
    &-title {
        background: #fff;
        margin: 0;
        font-size: 16px;
        height: 56px;
        font-weight: 400;
        line-height: 56px;
        text-indent: 16px;
        color: #777;
        & > .hint {
            font-size: 12px;
            margin-left: 0.5rem;
        }
    }
    /deep/ .item {
        cursor: pointer;
        background-color: #ffffff;
        height: 56px;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-right: 5px;
        padding-left: 10px;
        &.ks-1px-b {
            &::after {
                content: ' ';
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                height: 1px;
                border-bottom: 1px solid #e2e2e2;
                color: #e2e2e2;
                -webkit-transform-origin: 0 100%;
                transform-origin: 0 100%;
                -webkit-transform: scaleY(0.5);
                transform: scaleY(0.5);
            }
        }
        .text {
            flex: 1 1;
        }
        .icon-nav-forward {
            font-weight: bold;
            &::before {
                content: '\e036';
            }
        }
    }
    &-footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 60px;
        display: flex;
        padding: 0 20px;
        .iphoneX-padding(@direction: bottom);
        align-content: center;
        align-items: center;
        justify-content: center;
        background: #fff;
    }
}
</style>
